import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { TooltipProvider } from "./components/ui/tooltip";
import "./index.css";
import Layout from "./Layout";
import { queryClient } from "./lib/query-client";
import { AppConfig } from "./pages/AppConfig";
import { Dashboard } from "./pages/Dashboard";
import { ForgotPassword } from "./pages/ForgotPassword";
import { Incidents } from "./pages/Incidents";
import { NewApplication } from "./pages/NewApplication";
import { NewService } from "./pages/NewService";
import { NotFound } from "./pages/NotFound";
import { PublicAppStatus } from "./pages/PublicAppStatus";
import { PublicServiceStatus } from "./pages/PublicServiceStatus";
import { ResetPassword } from "./pages/ResetPassword";
import { ServiceConfig } from "./pages/ServiceConfig";
import { Settings } from "./pages/Settings";
import { SignIn } from "./pages/SignIn";
import { SignUp } from "./pages/SignUp";

export function App() {
	return (
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<TooltipProvider delayDuration={200} skipDelayDuration={0}>
					<Toaster position="bottom-center" />
					<BrowserRouter>
						<Routes>
							<Route path="/" element={<Layout />}>
								<Route
									index
									element={
										<ProtectedRoute>
											<Dashboard />
										</ProtectedRoute>
									}
								/>
								<Route path="sign-in" element={<SignIn />} />
								<Route path="sign-up" element={<SignUp />} />
								<Route path="forgot-password" element={<ForgotPassword />} />
								<Route path="reset-password" element={<ResetPassword />} />
								<Route
									path="new"
									element={
										<ProtectedRoute>
											<NewApplication />
										</ProtectedRoute>
									}
								/>
								<Route
									path="settings"
									element={
										<ProtectedRoute>
											<Settings />
										</ProtectedRoute>
									}
								/>
								<Route
									path="incidents"
									element={
										<ProtectedRoute>
											<Incidents />
										</ProtectedRoute>
									}
								/>
								<Route
									path=":appId"
									element={
										<ProtectedRoute>
											<AppConfig />
										</ProtectedRoute>
									}
								/>
								<Route
									path=":appId/new-service"
									element={
										<ProtectedRoute>
											<NewService />
										</ProtectedRoute>
									}
								/>
								<Route
									path=":appId/:serviceId"
									element={
										<ProtectedRoute>
											<ServiceConfig />
										</ProtectedRoute>
									}
								/>
								<Route path="public/:appId" element={<PublicAppStatus />} />
								<Route
									path="public/:appId/:serviceId"
									element={<PublicServiceStatus />}
								/>
								<Route path="404" element={<NotFound />} />
								<Route path="*" element={<NotFound />} />
							</Route>
						</Routes>
					</BrowserRouter>
				</TooltipProvider>
			</QueryClientProvider>
		</StrictMode>
	);
}

export default App;
